module.exports = __webpack_public_path__ + "img/keep-on-record.d0289dc0.png";